import React from 'react'
import { SEO } from '../../../components/Seo/seo'
import { nonCoreLinkRequests } from '../../../utils/pages-meta.json'
import { useIntl } from 'react-intl'
import { NonCoreLinkRequestsProvider } from '../../../nonCoreLinkRequestsContext'
import NonCoreLinkRequestsContent from '../../../components/Workspace/NonCoreLinkRequests'

const NonCoreLinkRequests = () => {
  const intl = useIntl()
  return (
    <>
      <SEO title={intl.formatMessage({ id: 'workspaceMenu.link.item13' })}
           pathname={window.location.origin}
           titleTemplate={intl.formatMessage({ id: 'E-Tax-Workspace' })}
           image={nonCoreLinkRequests.image}
           description={intl.formatMessage({ id: 'workspaceMenu.link.item13' })}
      />
      <NonCoreLinkRequestsProvider>
        <NonCoreLinkRequestsContent/>
      </NonCoreLinkRequestsProvider>
    </>
  )
}

export default NonCoreLinkRequests
